import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';
import { Observable } from 'rxjs/Rx';

import { TipoBateria } from './tipoBateria';

import myGlobals = require('../config');

@Injectable()
export class TipoBateriaService {

  private tipoBateriaUrl = myGlobals.default.BASE_URL + '/tipoBateria/';  // URL to web api

  constructor(private http: Http) { }

  //Obtener todos los tipoBaterias habilitados para el usuario
  getTipoBaterias() {
    return this.http.get(this.tipoBateriaUrl)
      .map((response) => response.json());
  }

  //Obtener un tipoBateria
  getTipoBateria(_id: string): Observable<TipoBateria> {
    return this.http.get(this.tipoBateriaUrl + _id)
      .map((response) => response.json());
  }


  save(tipoBateria: TipoBateria): Observable<TipoBateria> {
    if (tipoBateria._id) {
      return this.put(tipoBateria);
    }
    //Seteo estado activo
    tipoBateria.estado = true;
    return this.post(tipoBateria);
  }

  //Desactivar tipoBateria
  delete(tipoBateria: TipoBateria) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');

    let url = `${this.tipoBateriaUrl}/${tipoBateria._id}`;

    return this.http
      .delete(url, { headers: headers })
      .map((response) => response.json());
  }

  // Agregar nuevo tipoBateria
  private post(tipoBateria: TipoBateria): Observable<TipoBateria> {
    let headers = new Headers({
      'Content-Type': 'application/json;charset=UTF-8'
    });
    headers.append('dataType', 'json');
    console.log(tipoBateria);
    console.log(JSON.stringify(tipoBateria));
    var tipoBateriaStr = JSON.stringify(tipoBateria);
    return this.http
      .post(this.tipoBateriaUrl, tipoBateriaStr, { headers: headers })
      .map((response) => response.json());
  }

  // Actualizar tipoBateria
  private put(tipoBateria: TipoBateria) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');

    let url = `${this.tipoBateriaUrl}/${tipoBateria._id}`;

    return this.http
      .put(url, JSON.stringify(tipoBateria), { headers: headers })
      .map((response) => response.json());
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/tipoBateria/tipoBateria.service.ts